import { Suspense, useEffect, useContext, useState } from 'react';
import { useRoutes } from 'react-router-dom';
import routes from '~react-pages';
import { ConfigContext } from '@/config';
import ReactGA from 'react-ga4';

// components
import { CenteredCircularProgress } from '@/components/CenteredCircularProgress';
import { Header } from '@/components/Header';
import { Footer } from '@/components/Footer';
import { HelmetBlock } from './components/Helmet';

function App() {
  const config = useContext(ConfigContext);
  const [loading, setLoading] = useState(true);
  let reflectionFlag = false;

  useEffect(() => {
    if (!loading || reflectionFlag === true) {
      return;
    }
    const measurementAdId = String(config?.measurementAdId);
    initializeTagManager(measurementAdId);
    const measurementId = String(config?.measurementId);
    //     initializeGA(measurementId);
    ReactGA.initialize(measurementId);
    setLoading(false);
    reflectionFlag = true;
  }, [config]);

  return (
    <Suspense fallback={<CenteredCircularProgress />}>
      <div className="App font-noto">
        <HelmetBlock />
        <Header />
        {useRoutes(routes)}
        <Footer />
      </div>
    </Suspense>
  );
}

function initializeTagManager(measurementAdId: string) {
  const scriptHead = document.createElement('script');
  scriptHead.innerHTML =
    `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','` +
    measurementAdId +
    `');`;
  scriptHead.async = true;
  document.head.appendChild(scriptHead);

  const scriptBody = document.createElement('noscript');
  scriptBody.innerHTML =
    `<iframe src="https://www.googletagmanager.com/ns.html?id=` +
    measurementAdId +
    `" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
  document.body.appendChild(scriptBody);
}

export default App;
